import * as VueRouter from 'vue-router'
import qs from 'qs'

import routes from '@/router/routes'
import { useThirdPartyTools } from '@/composables/third-party-tools'
import { useMeta } from '@/composables/meta'
import { MaRouterErrorHandler } from '@/base/MaErrorHandlers'
import { Query } from '@/base/constants/route'
import { maBeforeEachGuard } from './guards'

const ARRAY_QUERIES = [Query.COUNTRY_CODES, Query.CATEGORIES]

const router = VueRouter.createRouter({
  history: VueRouter.createWebHistory(),
  parseQuery(query) {
    const parsedQuery = qs.parse(query, { arrayFormat: 'comma', encode: false })

    Object.keys(parsedQuery)
      .filter(queryKey => ARRAY_QUERIES.includes(queryKey))
      .forEach((queryKey) => {
        parsedQuery[queryKey] = parsedQuery[queryKey].split(',')
      })

    return parsedQuery
  },
  stringifyQuery: query => qs.stringify(query, { arrayFormat: 'comma', encode: false }),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition)
      return savedPosition

    if ((to.meta?.disabledAutoScroll && to.name == from.name))
      return {}

    const container = document.getElementById('container')
    if (container)
      container.scrollIntoView()
  },
})

router.beforeResolve((to) => {
  const { updateDocumentTitle } = useMeta()
  updateDocumentTitle(to.meta?.title, to.meta?.disableAuthCheck)
})

router.afterEach((to, from) => {
  const { sendPageTrackViewEvent } = useThirdPartyTools()
  sendPageTrackViewEvent(to, from)
})

router.beforeEach(maBeforeEachGuard)
router.onError(MaRouterErrorHandler)

export default router
